import { create } from 'zustand';

interface CCSwapState {
  open: boolean;
  targetClientID: string;
  targetClientName: string;
  ccUrl: string;
  requestSwap: (clientID: string, clientName: string, ccUrl: string) => void;
  close: () => void;
}

export const useCCSwapStore = create<CCSwapState>((set) => ({
  open: false,
  targetClientID: '',
  targetClientName: '',
  ccUrl: '',
  requestSwap: (targetClientID, targetClientName, ccUrl) =>
    set({ open: true, targetClientID, targetClientName, ccUrl }),
  close: () =>
    set({ open: false, targetClientID: '', targetClientName: '', ccUrl: '' }),
}));
